module.exports = __webpack_public_path__ + "static/media/instagram.845efd4e.svg";